import { AbstractDropDown, Option } from "../AbstractDropDown";
import React from "react";
import { FormikProps } from "formik";
import { Proposal } from "../../../types/Proposal";


const options:Option[]   = [
    {label: '', value: ''},
    {label: 'Studio', value: 'STUDIO'},
    {label: '1+1', value: 'ONE_ONE'},
    {label: '1+2', value: '2_BEDROOM'},
    {label: '1+3', value: '3_BEDROOM'},
];

const map = options.reduce((m, o) => {
    m[o.value] = o.label as string;
    return m;
}, {} as Record<string, string>);

export function getTypeLabel(key:string) {
    return map[key] || key;
}

interface ProposalTypeDropdownProps {
    onChange?: (v:string)=>void,
    value?:string,
    name?:string,
    label?:string
    submitHappen?:boolean
    disabled?:boolean
    formik?: FormikProps<Proposal>
}

export function ProposalTypeDropdown({value,disabled, submitHappen,formik, name, onChange, label}:ProposalTypeDropdownProps) {
    return <AbstractDropDown options={options}
                             disabled={disabled}
                             value={value}
                             label={label}
                             submitHappen={submitHappen}
                             //@ts-ignore
                             formik={formik}
                             name={name}
                             onChange={onChange}/>
}